import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import { AlertComponent } from '../../../../../common/alert/alert.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import { ToNumberPipe } from '../../../../../pipes/to-number.pipe';

@Component({
  selector: 'app-opinion-on-the-project-of-traffic-org-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    AlertComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    ToNumberPipe
  ],
  templateUrl: './opinion-on-the-project-of-traffic-org-preview.component.html'
})
export class OpinionOnTheProjectOfTrafficOrgPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  constructor() {
  }

  public ngOnInit(): void {
  }
}
